module.exports = __webpack_public_path__ + "img/view_list.da7e990b.svg";